<template>
  <div class="home-box">
    <div class="left">
      <div class="">
        <div class="text-xl font-bold">数据看板</div>
        
      </div>
      <div class="life-content">
        <div class="life-num">
          <div class="">
            <div class="ts pb-5 pt-5 text-sm font-bold" style="padding: 24px 0 0 18px;">
              <span class="ml-1">核心数据</span>
            </div>

            <div class="life-core-radio-group text-sm mt-5" style="margin: 10px 10px 10px;">
              <div
                class="item"
                @click="bindactive(1)"
                :class="active == 1 ? 'active' : ''"
              >
                今日
              </div>
              <div
                class="item"
                @click="bindactive(2)"
                :class="active == 2 ? 'active' : ''"
              >
                近7日
              </div>
              <div
                class="item"
                @click="bindactive(3)"
                :class="active == 3 ? 'active' : ''"
              >
                近30日
              </div>

              <div class="ml-5">
                <el-date-picker
                  v-model="dateValue"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="dateChange"
                >
                </el-date-picker>
              </div>
            </div>

            <div class="data-content pt-16px pb-5 pt-6">
              <div class="content-item">
                <div>核销GMV</div>
                <div class="col000 mt-5">
                  ¥
                  <span class="fz-34">{{ statData.count }}</span>
                </div>
              </div>
              <div class="content-item">
                <div>核销订单数</div>
                <div class="col000 mt-5">
                  <!-- ¥ -->
                  <span class="fz-34">{{ statData.num }}</span>
                </div>
              </div>
              <div class="content-item">
                <div>合作商家数</div>
                <div class="col000 mt-5">
                  <!-- ¥ -->
                  <span class="fz-34">{{ statData.store_num }}</span>
                </div>
              </div>
              <div class="content-item">
                <div>商家提现金额</div>
                <div class="col000 mt-5">
                  ¥
                  <span class="fz-34">{{ statData.withdraw }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="" v-loading="loading">
            <div class="ts pb-5 pt-5 text-sm font-bold">
              <span class="ml-1">佣金</span>
            </div>
            <div class="data-content expand-data-content pt-16px pb-5 pt-6" v-loading="countLoading">
              <div class="content-item">
                <div>今日佣金</div>
                <div class="col000 mt-5">
                  <span class="fz-34">{{countData.dangtian_balance}}</span>
                </div>
              </div>
              <div class="content-item">
                <div>本周佣金</div>
                <div class="col000 mt-5">
                  <span class="fz-34">{{countData.yz_balance}}</span>
                </div>
              </div>
              <div class="content-item">
                <div>本月佣金</div>
                <div class="col000 mt-5">
                  <span class="fz-34">{{countData.by_balance}}</span>
                </div>
              </div>
              <!-- <div class="content-item">
                <div>本周拓展商户</div>
                <div class="col000 mt-5">
                  <span class="fz-34">0</span>
                </div>
              </div>
              <div class="content-item">
                <div>上周拓展商户</div>
                <div class="col000 mt-5">
                  <span class="fz-34">0</span>
                </div>
              </div>
              <div class="content-item">
                <div>本月拓展商户</div>
                <div class="col000 mt-5">
                  <span class="fz-34">0</span>
                </div>
              </div>
              <div class="content-item">
                <div>上月拓展商户</div>
                <div class="col000 mt-5">
                  <span class="fz-34">0</span>
                </div>
              </div> -->
            </div>
          </div>

          <!-- <div class="">
            <div class="ts pb-5 pt-5 text-sm font-bold">
              <span class="ml-1">线下交易数据</span>
            </div>
            <div class="data-content offline-data-content pt-16px pb-5 pt-6">
              <div class="content-item">
                <div>
                  <div>总收款金额(元)</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
                <div class="mt-5">
                  <div>总交易笔数</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
              </div>
              <div class="content-item">
                <div>
                  <div>今日收款金额(元)</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
                <div class="mt-5">
                  <div>今日交易笔数</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
              </div>
              <div class="content-item">
                <div>
                  <div>近30天收款金额(元)</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
                <div class="mt-5">
                  <div>近30天交易笔数</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
              </div>
              <div class="content-item">
                <div>
                  <div>本周交易金额(元)</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
                <div class="mt-5">
                  <div>本周交易笔数</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
              </div>
              <div class="content-item">
                <div>
                  <div>上周交易金额(元)</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
                <div class="mt-5">
                  <div>上周交易笔数</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
              </div>
              <div class="content-item">
                <div>
                  <div>本月收款金额(元)</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
                <div class="mt-5">
                  <div>本月交易笔数</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
              </div>
              <div class="content-item">
                <div>
                  <div>上月交易额(元)</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
                <div class="mt-5">
                  <div>上月交易笔数</div>
                  <div class="col000 mt-5">
                    <span class="fz-34">0</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->

          <!-- <div class="">
            <div class="ts pb-5 pt-5 text-sm font-bold">
              <span class="ml-1">常用功能</span>
            </div>
            <div class="fuc-content">
              <div class="content-item" @click="toLinks('商品管理')">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAHASURBVFiF7Zm9cQIxEEa/1bgDurjQiu0GSJnBBTBQgB0TEJsCYCjgPENKAyblCOmCGtaBWCOfEZa0gAj8Zi64H3TvVtLu6SAc4JfHJzANQOiC0UEJCHswViBeUL1du0MAuG/fAbwWkQozpY/mjQ6R+yxtcxLiZwOmQWmPIEwDA0K3tEcQQtcUmxAxMDqmtMNf/AtqebhIK70hUFm3AcCucdtyrm5aF8HKAvXGCYqYSPWG7pxIZ0Lct5z963pzlNo1P8/1hm7bNcBklH2L/AhK1E7JyfHJyEVwPMu+jU4wJCfIWFR08/VnsXKi5I/Byp6PXu61LeLTTGWP6USDDItI4TTByupzW+LMjheUhi+QfL8zQATxk6TdJTFdLinGF0ocj2mz2JeRG5+LhjzATQTbjcp+5uyMJX4MiohEQKrEOcH2NRkZQJeoY6LnX+O/7USS3sXaPOi3FUFaBJV1Naei3PaN+uqC2ghmkC4I5EkmVA+ftDWJFPnxLK3k+Q+UWCrTF03L+e/qEEPmq79uTXID7n5d/C+oxYCwLy0RhLA3YKxKewRhrAyIF6U9ghAvzOFr+rS0ywmmVG/XJHv3+jfEF57Gs0Na3LXSAAAAAElFTkSuQmCC"
                    class="icon"
                  />
                  <div>商品管理</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item" @click="toLinks('AI矩阵')">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAGWSURBVFiF7ZnNbYQwEIWfrXSwHVBC2Gty4rZtrEgB+dsSViEUsIg29sYpXBdKoANawDkYC6TwY3tnMYnySQgh2eIxM2/GEgwt96/igXHsAewAbOCGGsBZNEjLiOUAwADAfxOfYHh2JGoYgbj4YC+sjdyXaz1DiAaPvE3rKmEcew5Zc2tlx+HOEDpsuGsFc/wLvBYjgWEAnMJbSRnGOIK+dwsZ49zpLPK97gJkJG1IMvM9zH8XYm7RKaSL3PZgtl4rgk+JvIeBvExfAsgPVB9aVPr7FnOxEmWaidW3Ga0UzxEGXepsjDAFWQR9Twq9HO1dPgSJQFVXKnrKTBSQ1mCSSYcXFd3UITeJqkfArJ2MQWISRb/PJdmKBBZVNwqTjNbJJAKVoKKiiVofshRT9z/F6ieJkUDbeXoNWsetPpcjzYuLqjslTWFcg9uD/ZQIg85IumayMomtIZRAk/2LmsSmBRnX4NL8rTbjgl8hsHYtYoKaAzi7VjHBmYsGqWsVY4gGKS8jlkMgdi3mBwJxGbGcqee1/ob4Bum9fIcyTpVwAAAAAElFTkSuQmCC"
                    class="icon"
                  />
                  <div>AI矩阵</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item" @click="toLinks('AI实景直播')">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAINSURBVFiF7ZnRTcMwEIb/S9mAp0K6B65UFugrbNAJUsQQiHSCbgCvXYBKpHukok8dAR0P7hGnNKXnODII/je7dfzp7vz7ohB24ll/BMYERGMwzhFDhC2YF3jHnO43SzsFgB8vHkGYRoFqEiOnu7c74of+CD16ic1zUMTXCXqYxOZoFGOSgGgcm6NRROMk2oE4RYzzJDbDd/oHbKtwgAMD3D4DJgv2SCAUoMks3MAEeZyr9oAmA8wUKHKgLIB0GACrUjtAF66YBUKqK0yKBW79Wp83WeuaPGu1WqInWhd2zv1d5svCawt/wGMHYmCANMyBaZ/itROZchepq2n94Fz5d3I6wIH5WlP7qVvl9ejK2NOCdICpsZFxN9vfuHTqTWqvLKxPdg+487jb5+M1tsoPjz1OtD7FEh1zpK7KAni6qf4rUTy2JgggYL3u6aYaN0XyUG0C6lrUA6ZDu/ns0p7S9Yn+JsBK+9H54H5UOrreXOkj6NuxyLpTI76TDtCzjgBUqVVeeTpA19O0kPv39onSp1iiqIEU//OoWT2geBzwfYv/+RowrVuTQsT5BXutBKqGFbDg0g/KjSPGvsq92612gC5oOqxSLjAtwERhADvUH3ov7ki/AJCwjQ3RKMI2AfMiNkejmBcJCPPYHI16xzyhbLMEQ39Jdi1GTvebJX2OH/oj9H7IZwjCnDL7GeID3T281OpI0zsAAAAASUVORK5CYII="
                    class="icon"
                  />
                  <div>AI实景直播</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div> -->
              <!-- <div class="content-item" @click="toLinks('快学推推')">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAJFSURBVFiF7ZkxctpAFECfVrmAsHQBaExPqyAXyXiGLhnfgBskPagPN+AGjNMxwzgFcmjp5QYuIEAnEEph7xo7CFgJZ1P4dRJoePy//+uvZCGZjHxsu0ued4ALzLDGYky2HXJ9MwOwALi7/QF8MyRVxIDPX79bTEY+Qvw2bbOX7fajwBZd0x6F2HZXkNMx7VFInncE5griFC6EaYNjvAtW5UOViwPHo+24BDVXHUdpQrRZARAuY3OCvXqTfqMJQJQmAPQXj0LyfFBziTarSqKlBKVclCZczWd/fR4uY/WdwPHUuTJY3N3mZeT6i/ikH522fALH42o+U5HWQatIdOUAJdZrXGrLaQtKdNMVLh4IHE+lWwctwaDmlkpTFfQEHU+1EB2iNCFKE9qOq32tVpFMWz7A3sp9K94sgkXrTXcdnizYqz823/v0uGCv3mTa8tU1u3Ky7ZxdUDZmnSKRd5QqnC64iAkcj/zTl6MRkH8G9FNaWjBcxli/fgIcbLoyrVUbtLag5FiKZfRkQZVt0BLtYSHarNR49RoZvcDxCFrPUr3GJdG8XIOvNA8Wsdsn2477YqrRRTvF9+lKFcvrNiIHCVntUZoQLuNKa1E/xWnyYjANaq6KWNGUEy4eSslBiXlwF9l4dWY9uS04lbOswbbjHhwEdqOqOw2dRfDYHaPKnqRSiv8F//2++F2wKgJYm5Y4wFpgWWPTFoVYjAVZNjTtUUi2HYqnp+kD0y57GHB9M7PU4WTkY4vu0yNhg68hrDFZpl5D/AHMPPPFnOlF1wAAAABJRU5ErkJggg=="
                    class="icon"
                  />
                  <div>快学推推</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item" @click="toLinks('聚合推广')">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAIISURBVFiF7ZmxTuswFECPDWM2lo6txB6kziCVjv2HDqh/UBYk3sSTWF7+oOrQf+gYkOiMIHulduzClpWUob0h6mtprgOYgbO0kezk+Nq+dhzDmvbjn1MsPVh2gCP88AKMyV4HcfN2AmAA2s/X/1jS9yS1HUMUn/y9NO3Hq1PswYNvn61k5sxiD3q+PXZi6Vmg49tjN8uOxd+EKMOR9W2wj1/BqhxWqRwGDcKgvv5tADBa3AGQpHOSdOZHMAwadGutXKpIt3ae/x8t7hgt7t3tANN+ul5qKnRrrVxCIlSUCIP6p4qqBItyZR4aHV/kUe5Ph05dXnqSaOU2pbq1llpOKaiTE0RSxu2XCBZv7DKWpM62SbUPVR6UFKJFuvnLBF1uvImrpEqwak5b3auuKq/q4iqRdF1VSgl+xpIljUvSuaqeKoKuuQyKgrrGlhIspgmXbpaGuWSB0l3suiIUVyAXSndxMYplJVdl3VYgQbVZCIMG0fFFfr3roZvbsSSd0Z8O1XJqwW2SIiDrrZQRpBHv41AXRbWgsG9sJemM0eI+H7uy9dJG01lQkG3/u9g8F9zERbKyoBatZKWXJhf606EqVX27IOgmyo9/L/4VrIpldez6U3mxYMa+LT5gbMkY+LbYSfY6sHHzZoIh8u3yH4Yobt5OjFyvD9N7rI6EPX6GMGMyBnHzZgLwBmfz8G2Fl/SKAAAAAElFTkSuQmCC"
                    class="icon"
                  />
                  <div>聚合推广</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item" @click="toLinks('客推店')">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/svg+xml;base64,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"
                    class="icon"
                  />
                  <div>客推店</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div> -->
            <!-- </div>
          </div> -->


          <!-- <div class="">
            <div class="ts pb-5 pt-5 text-sm font-bold">
              <span class="ml-1">相关功能</span>
            </div>
            <div class="fuc-content">
              <div class="content-item">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAHASURBVFiF7Zm9cQIxEEa/1bgDurjQiu0GSJnBBTBQgB0TEJsCYCjgPENKAyblCOmCGtaBWCOfEZa0gAj8Zi64H3TvVtLu6SAc4JfHJzANQOiC0UEJCHswViBeUL1du0MAuG/fAbwWkQozpY/mjQ6R+yxtcxLiZwOmQWmPIEwDA0K3tEcQQtcUmxAxMDqmtMNf/AtqebhIK70hUFm3AcCucdtyrm5aF8HKAvXGCYqYSPWG7pxIZ0Lct5z963pzlNo1P8/1hm7bNcBklH2L/AhK1E7JyfHJyEVwPMu+jU4wJCfIWFR08/VnsXKi5I/Byp6PXu61LeLTTGWP6USDDItI4TTByupzW+LMjheUhi+QfL8zQATxk6TdJTFdLinGF0ocj2mz2JeRG5+LhjzATQTbjcp+5uyMJX4MiohEQKrEOcH2NRkZQJeoY6LnX+O/7USS3sXaPOi3FUFaBJV1Naei3PaN+uqC2ghmkC4I5EkmVA+ftDWJFPnxLK3k+Q+UWCrTF03L+e/qEEPmq79uTXID7n5d/C+oxYCwLy0RhLA3YKxKewRhrAyIF6U9ghAvzOFr+rS0ywmmVG/XJHv3+jfEF57Gs0Na3LXSAAAAAElFTkSuQmCC"
                    class="icon"
                  />
                  <div>网付</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAGWSURBVFiF7ZnNbYQwEIWfrXSwHVBC2Gty4rZtrEgB+dsSViEUsIg29sYpXBdKoANawDkYC6TwY3tnMYnySQgh2eIxM2/GEgwt96/igXHsAewAbOCGGsBZNEjLiOUAwADAfxOfYHh2JGoYgbj4YC+sjdyXaz1DiAaPvE3rKmEcew5Zc2tlx+HOEDpsuGsFc/wLvBYjgWEAnMJbSRnGOIK+dwsZ49zpLPK97gJkJG1IMvM9zH8XYm7RKaSL3PZgtl4rgk+JvIeBvExfAsgPVB9aVPr7FnOxEmWaidW3Ga0UzxEGXepsjDAFWQR9Twq9HO1dPgSJQFVXKnrKTBSQ1mCSSYcXFd3UITeJqkfArJ2MQWISRb/PJdmKBBZVNwqTjNbJJAKVoKKiiVofshRT9z/F6ieJkUDbeXoNWsetPpcjzYuLqjslTWFcg9uD/ZQIg85IumayMomtIZRAk/2LmsSmBRnX4NL8rTbjgl8hsHYtYoKaAzi7VjHBmYsGqWsVY4gGKS8jlkMgdi3mBwJxGbGcqee1/ob4Bum9fIcyTpVwAAAAAElFTkSuQmCC"
                    class="icon"
                  />
                  <div>易城市</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAINSURBVFiF7ZnRTcMwEIb/S9mAp0K6B65UFugrbNAJUsQQiHSCbgCvXYBKpHukok8dAR0P7hGnNKXnODII/je7dfzp7vz7ohB24ll/BMYERGMwzhFDhC2YF3jHnO43SzsFgB8vHkGYRoFqEiOnu7c74of+CD16ic1zUMTXCXqYxOZoFGOSgGgcm6NRROMk2oE4RYzzJDbDd/oHbKtwgAMD3D4DJgv2SCAUoMks3MAEeZyr9oAmA8wUKHKgLIB0GACrUjtAF66YBUKqK0yKBW79Wp83WeuaPGu1WqInWhd2zv1d5svCawt/wGMHYmCANMyBaZ/itROZchepq2n94Fz5d3I6wIH5WlP7qVvl9ejK2NOCdICpsZFxN9vfuHTqTWqvLKxPdg+487jb5+M1tsoPjz1OtD7FEh1zpK7KAni6qf4rUTy2JgggYL3u6aYaN0XyUG0C6lrUA6ZDu/ns0p7S9Yn+JsBK+9H54H5UOrreXOkj6NuxyLpTI76TDtCzjgBUqVVeeTpA19O0kPv39onSp1iiqIEU//OoWT2geBzwfYv/+RowrVuTQsT5BXutBKqGFbDg0g/KjSPGvsq92612gC5oOqxSLjAtwERhADvUH3ov7ki/AJCwjQ3RKMI2AfMiNkejmBcJCPPYHI16xzyhbLMEQ39Jdi1GTvebJX2OH/oj9H7IZwjCnDL7GeID3T281OpI0zsAAAAASUVORK5CYII="
                    class="icon"
                  />
                  <div>钱如潮</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAJFSURBVFiF7ZkxctpAFECfVrmAsHQBaExPqyAXyXiGLhnfgBskPagPN+AGjNMxwzgFcmjp5QYuIEAnEEph7xo7CFgJZ1P4dRJoePy//+uvZCGZjHxsu0ued4ALzLDGYky2HXJ9MwOwALi7/QF8MyRVxIDPX79bTEY+Qvw2bbOX7fajwBZd0x6F2HZXkNMx7VFInncE5griFC6EaYNjvAtW5UOViwPHo+24BDVXHUdpQrRZARAuY3OCvXqTfqMJQJQmAPQXj0LyfFBziTarSqKlBKVclCZczWd/fR4uY/WdwPHUuTJY3N3mZeT6i/ikH522fALH42o+U5HWQatIdOUAJdZrXGrLaQtKdNMVLh4IHE+lWwctwaDmlkpTFfQEHU+1EB2iNCFKE9qOq32tVpFMWz7A3sp9K94sgkXrTXcdnizYqz823/v0uGCv3mTa8tU1u3Ky7ZxdUDZmnSKRd5QqnC64iAkcj/zTl6MRkH8G9FNaWjBcxli/fgIcbLoyrVUbtLag5FiKZfRkQZVt0BLtYSHarNR49RoZvcDxCFrPUr3GJdG8XIOvNA8Wsdsn2477YqrRRTvF9+lKFcvrNiIHCVntUZoQLuNKa1E/xWnyYjANaq6KWNGUEy4eSslBiXlwF9l4dWY9uS04lbOswbbjHhwEdqOqOw2dRfDYHaPKnqRSiv8F//2++F2wKgJYm5Y4wFpgWWPTFoVYjAVZNjTtUUi2HYqnp+kD0y57GHB9M7PU4WTkY4vu0yNhg68hrDFZpl5D/AHMPPPFnOlF1wAAAABJRU5ErkJggg=="
                    class="icon"
                  />
                  <div>码点餐</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="content-item">
                <div class="p-flex-cen">
                  <img
                    data-v-3e4f5bef=""
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAIISURBVFiF7ZmxTuswFECPDWM2lo6txB6kziCVjv2HDqh/UBYk3sSTWF7+oOrQf+gYkOiMIHulduzClpWUob0h6mtprgOYgbO0kezk+Nq+dhzDmvbjn1MsPVh2gCP88AKMyV4HcfN2AmAA2s/X/1jS9yS1HUMUn/y9NO3Hq1PswYNvn61k5sxiD3q+PXZi6Vmg49tjN8uOxd+EKMOR9W2wj1/BqhxWqRwGDcKgvv5tADBa3AGQpHOSdOZHMAwadGutXKpIt3ae/x8t7hgt7t3tANN+ul5qKnRrrVxCIlSUCIP6p4qqBItyZR4aHV/kUe5Ph05dXnqSaOU2pbq1llpOKaiTE0RSxu2XCBZv7DKWpM62SbUPVR6UFKJFuvnLBF1uvImrpEqwak5b3auuKq/q4iqRdF1VSgl+xpIljUvSuaqeKoKuuQyKgrrGlhIspgmXbpaGuWSB0l3suiIUVyAXSndxMYplJVdl3VYgQbVZCIMG0fFFfr3roZvbsSSd0Z8O1XJqwW2SIiDrrZQRpBHv41AXRbWgsG9sJemM0eI+H7uy9dJG01lQkG3/u9g8F9zERbKyoBatZKWXJhf606EqVX27IOgmyo9/L/4VrIpldez6U3mxYMa+LT5gbMkY+LbYSfY6sHHzZoIh8u3yH4Yobt5OjFyvD9N7rI6EPX6GMGMyBnHzZgLwBmfz8G2Fl/SKAAAAAElFTkSuQmCC"
                    class="icon"
                  />
                  <div>微火</div>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div> -->
        </div>
        <!-- <div id="chart" style="width: 600px; height: 400px"></div> -->
      </div>
    </div>
    <div class="rig">
      <!-- <div class="classify">
        <div class="pubtit">
          <h2>待办事项</h2>
        </div>
        <div class="none">暂无待办事项</div>
      </div>
      <div class="classify">
        <div class="pubtit">
          <h2>常用功能</h2>
        </div>
        <div class="list">
          <div class="item">
            <img src="../assets/home1.png" alt="" />
            <div class="text">商品管理</div>
          </div>
          <div class="item">
            <img src="../assets/home2.png" alt="" />
            <div class="text">核销明细</div>
          </div>
          <div class="item">
            <img src="../assets/home3.png" alt="" />
            <div class="text">售卖明细</div>
          </div>
          <div class="item">
            <img src="../assets/home4.png" alt="" />
            <div class="text">门店管理</div>
          </div>
          <div class="item">
            <img src="../assets/home5.png" alt="" />
            <div class="text">授权管理</div>
          </div>
          <div class="item">
            <img src="../assets/home6.png" alt="" />
            <div class="text">提现记录</div>
          </div>
        </div>
      </div> -->

      <div class="classify">
        <div class="pubtit">
          <div class="font-bold text-xl">公告</div>
          <div class="more">查看更多<i class="el-icon-arrow-right"></i></div>
        </div>

        <div class="list newlist mt-5">
          <div v-for="item in noticeList" class="item" :key="item.id" @click="goNoticeInfo(item.id)">
            <div class="text">{{item.title}}</div>
            <div class="data">{{item.createdate}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- dialog -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="30%" @close="dialogFormClose">
      <el-image :src="qrCodeSrc">
        <div slot="placeholder" class="image-slot">
          加载中<span class="dot">...</span>
        </div>
      </el-image>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import axios from "axios";

export default({
  name: "Home",
  data() {
    return {
      active: 1,
      numactive: 1,
      loading: true,

      dateValue: "",
      statData: {},
      title: '',
      dialogFormVisible: false,
      qrCodeSrc: '',

      noticeList: [],
      countData: {},
      countLoading: false,
    };
  },
  computed: {
    ...mapState(["user", "setting"]),
  },
  mounted() {
    let user = JSON.parse(localStorage.user);
    this.token = user.token;
    // this.getautoshow()
    // this.getInfo()
    // this.getechart();
    this.getDataStat(this.active)
    this.getNotice()
    this.getCount(this.active)
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  },
  methods: {
    ...mapMutations(["setuser", "setsetting"]),
    getechart() {
      // 基于准备好的dom，初始化echarts实例
      var myChart = this.$echarts.init(document.getElementById("chart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "核销券数",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          // prettier-ignore
          data: ['00:00', '01:15', '02:30', '03:45', '05:00', '06:15', '07:30', '08:45', '10:00', '11:15', '12:30', '13:45', '15:00', '16:15', '17:30', '18:45', '20:00', '21:15', '22:30', '23:45'],
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
          axisPointer: {
            snap: true,
          },
        },
        series: [
          {
            smooth: true,
            data: [
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              12,
              33,
              222,
              333,
              123,
              233,
              112,
              212,
              444,
              333,
              1,
              11,
              22,
            ],
            type: "line",
          },
        ],
      });
    },
    getInfo() {
      axios
        .post("http://shunyu.jnwww.top/admin.php?action=setting&method=store", {
          is_get: 1,
          token: this.token,
        })
        .then((res) => {
          console.log(res);
          if (res.data.msg == "登录已过期") {
            localStorage.removeItem("user");
            this.$router.replace("/");
            return;
          }
          let data = {
            store: res.data.data.store_name,
            logo: res.data.data.store_logo,
          };
          this.setsetting(data);
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    getautoshow() {
      axios
        .get(
          "http://shunyu.jnwww.top/admin.php?action=autoshow&method=ex_list",
          {
            params: {
              token: this.token,
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录已过期") {
            localStorage.removeItem("user");
            this.$router.replace("/");
            return;
          }
          res.data.data.data.forEach((item) => {
            this.options.push({
              label: item.exhibition_title,
              value: item.exhibition_id,
            });
            this.value = res.data.data.data[0].exhibition_id;
            this.getList();
          });
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    getList() {
      axios
        .post(
          "http://shunyu.jnwww.top/admin.php?action=autoshow&method=tk_list",
          {
            exhibition_ids: this.value,
            begin_time: this.date[0],
            end_time: this.date[1],
            page_idx: this.page,
            page_size: 10,
            token: this.token,
          }
        )
        .then((res) => {
          this.tableData = res.data.data.data;
          if (res.data.data.data.length == 0) {
            this.empty = this.page;
            this.$message.error("已无数据");
          } else {
            this.empty = 10000000000000000;
          }
        })
        .catch((err) => {
          this.$message.error(err.msg);
        });
    },
    // 今日/近7日/近30日按钮切换
    bindactive(e) {
      this.countLoading = true
      this.active = e;
      this.getCount(this.active)
      this.getDataStat(this.active)
    },
    bindnumactive(e) {
      this.numactive = e;
    },
    dateChange() {
      console.log('dateValue', this.dateValue);
      let data = {
        startDate: this.dateValue[0],
        endDate: this.dateValue[1],
      }
      this.$api.dataStat(data).then(res=>{
        if(res.code == 'success'){
          this.statData = res.data
        }else{
          this.$message.error(res.msg)
        }
        this.countLoading = false
      }).catch(err=>{
        this.$message.error(err.msg)
        this.countLoading = false
      });
    },
    // 获取核心数据模块数据统计
    getDataStat(type) {
      let data = {
        type
      }
      this.$api.dataStat(data).then(res=>{
        if(res.code == 'success'){
          this.statData = res.data
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err=>{
        this.$message.error(err.msg)
      });
    },
    // 常用功能页面跳转
    toLinks(key){
      switch (key) {
        case '商品管理':
          window.open('https://life.douyin.com', '_blank');
          break;
        case 'AI矩阵':
          this.$api.getQrCode({}).then(res=>{
              if(res.code == 'success'){
                this.qrCodeSrc = res.data.juzhen
              }else{
                this.$message.error(res.msg)
              }
          }).catch(err=>{
            this.$message.error(err.msg)
          });
          this.title = 'AI矩阵'
          this.dialogFormVisible = true
          break;
        case 'AI实景直播':
          this.$api.getQrCode({}).then(res=>{
              if(res.code == 'success'){
                this.qrCodeSrc = res.data.aisjzb
              }else{
                this.$message.error(res.msg)
              }
          }).catch(err=>{
            this.$message.error(err.msg)
          });
          this.title = 'AI实景直播'
          this.dialogFormVisible = true
          break;
        case '快学推推':
          window.open('https://kuaixue.yunmaitui.com', '_blank');
          break;
        case '聚合推广':
          window.open('https://tuoke.maronettee.com', '_blank');
          break;
        case '客推店':
          window.open('https://ketui.yunmaitui.com', '_blank');
          break;

        default:
          break;
      }
    },
    // model关闭
    dialogFormClose(){
      this.qrCodeSrc = ''
      this.dialogFormVisible = false
    },
    // 获取佣金数据
    getCount(type) {
      this.$api.getCount({type}).then(res=>{
        if(res.code == 'success'){
          this.countData = res.data
        }else{
          this.$message.error(res.msg)
        }
        this.countLoading = false
      }).catch(err=>{
        this.$message.error(err.msg)
        this.countLoading = false
      });
    },
    // 获取公告列表
    getNotice() {
      this.$api.getNotice({}).then(res=>{
        if(res.code == 'success'){
          this.noticeList = res.data
        }else{
          this.$message.error(res.msg)
        }
      }).catch(err=>{
        this.$message.error(err.msg)
      });
    },
    // 跳转公告详情
    goNoticeInfo(id) {
      this.$router.push({path:'home/noticeInfo',query: {id}})
    },
  },
});
</script>

<style scoped lang="less">
.home-box {
  // margin: 20px 0 0 20px;
  border-radius: 20px;
  background: #ffffff;
  overflow: auto;
  padding: 16px 16px 0;
  box-sizing: border-box;
  display: flex;
  width: 100%;
}
.left {
  flex-grow: 1;
  flex-shrink: 1;
  padding: 20px 32px;
  width: 200px;
  .life-core-radio-group {
    display: flex;
    align-items: center;
    border-radius: 4px;
    color: #64676c;
    .item {
      border: solid 1px #e0e0e0;
      padding: 0 11px;
      height: 32px;
      line-height: 32px;
      border-radius: 3px;
      margin-right: 10px;
      display: inline-block;
      color: #333;
      cursor: pointer;
    }
    .active {
      background-color: #33c16f;
      border-color: #33c16f;
      color: #fff;
    }
  }

  .life-content {
    .life-num {
      .ts {
        color: #333;
        font-size: 13px;
        line-height: 19px;
        padding: 24px 0 24px 18px;
        box-sizing: border-box;
        font-weight: 700;
        display: flex;
        flex-direction: row;
        align-items: center;
      }
      .ts::before {
        display: inline-block;
        content: "";
        width: 3px;
        height: 19px;
        background: rgb(71, 122, 255);
      }
      .data-content {
        display: flex;
        width: 100%;
        border-radius: 4px;
        background: rgb(255, 255, 255);
        border: 1px solid rgb(232, 232, 232);
        .content-item {
          position: relative;
          margin-left: 38px;
          width: 230px;
          font-size: 14px;
          line-height: 20px;
          color: #5a607f;
          box-sizing: border-box;
        }
      }
      .expand-data-content {
        .content-item::before {
          content: "";
          width: 1px;
          height: 40px;
          background: #d7dbec;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }
      .offline-data-content {
        .content-item::before {
          content: "";
          width: 1px;
          height: 80px;
          background: #d7dbec;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
        }
      }

      .fuc-content {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .content-item {
          cursor: pointer;
          width: 20%;
          height: 63px;
          border-radius: 4px;
          background: rgb(255, 255, 255);
          border: 1px solid rgb(232, 232, 232);
          padding: 0 15px;
          box-sizing: border-box;
          font-size: 14px;
          font-weight: 400;
          color: #5a607f;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-right: 40px;
          margin-bottom: 20px;
          img {
            width: 40px;
            height: 40px;
            margin-right: 14px;
          }
        }
      }
    }
  }
}
.rig {
  border-left: 1px solid #f0f2f5;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 20px 32px;
  width: 337px;
  .classify {
    margin-bottom: 48px;
    .pubtit {
      display: flex;
      align-content: center;
      justify-content: space-between;
    }
    .more {
      color: #1d2129;
      font-family: PingFang SC;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
    }
    .list {
      border: 1px solid #f0f2f5;
      border-radius: 12px;
      display: flex;
      flex-wrap: wrap;

      padding: 15px 12px 6px;
      .item {
        text-align: center;
        cursor: pointer;
        width: 33%;
        margin-bottom: 10px;
        img {
          height: 32px;
          margin: 0 auto;
          width: 32px;
        }
        .text {
          color: #707880;
          font-family: PingFang SC;
          font-size: 15px;
          font-style: normal;
          font-weight: 900;
          line-height: 22px;
        }
        span {
          background: linear-gradient(90deg, #fa7500, #fa6400);
          border-radius: 100px;
          box-sizing: border-box;
          color: #fff;
          font-size: 10px;
          font-weight: 600;
          height: 16px;
          line-height: 16px;
          margin-left: 4px;
          padding: 0 4px;
          text-align: center;
        }
        .data {
          color: #6c737a;
          font-size: 12px;
          line-height: 18px;
          margin-top: 2px;
        }
      }
    }
    .newlist {
      flex-wrap: nowrap;
      display: block;
      .item {
        width: 100%;
        margin-bottom: 16px;
        text-align: left;
      }
    }
  }
}

:deep(.el-loading-spinner){
    top: 30%;
    margin-left: 50%;
}

@media screen and (max-width: 750px) {
}

</style>
